export default __webpack_public_path__ + "images/M0.9ef8c4a.png";